import React from "react";
import OfferTable from "components/Tables/Offer/OfferTable";

const ListOffer = () => {
  return (
    <div>
      <OfferTable />
    </div>
  );
};

export default ListOffer;
